module.exports = __webpack_public_path__ + "img/success.126a395d.svg";